import type { QueryClient } from "@tanstack/react-query";
import type { WebsocketShippingConfigurationChanged } from "@intelligems/ig-types/functions/meta/web-socket/web-socket";
import { shippingConfigurationKey } from "@src/api/shipping-configuration/get-shipping-configuration";
import { shippingProfileBackupKeys } from "@src/api/queryKeys";

export async function handleShippingConfigurationChanged(
  message: WebsocketShippingConfigurationChanged,
  orgId: string,
  queryClient: QueryClient
) {
  if (message.orgId !== orgId) {
    return;
  }
  await Promise.all([
    queryClient.invalidateQueries({ queryKey: shippingConfigurationKey }),
    queryClient.invalidateQueries({ queryKey: shippingProfileBackupKeys.all }),
  ]);
}
